<template>
    <div>
    <!-- <NavbarHorizontalVue v-if="Cambios"/>   -->
    <!-- <NavbarHorizontalVue />    -->
 
    <NavbarVerticalVue />
  
    </div>
</template>

<script>
// import NavbarHorizontalVue from '../../components/Navbar/NavbarHorizontal.vue';
import NavbarVerticalVue from '../../components/Navbar/NavbarVertical.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'BYNavbar',
    components:{
        // NavbarHorizontalVue,
        NavbarVerticalVue
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
    computed:{
        ...mapGetters('acciones', ['Cambios'])
  },
};
</script>

<style scoped>

</style>